// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_section__Kuf0D {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center; }

.styles_connectionSection__WSQWQ {
  width: 100%; }

.styles_contentWrapper__wJ6Mv {
  margin: 0 auto;
  text-align: center; }

.styles_headerSection__7fndT {
  margin-bottom: 3rem; }

.styles_sectionTitle__arYwS {
  font-size: 2.5rem;
  font-weight: 300;
  color: #808080e6;
  margin-bottom: 1.5rem; }
  @media (min-width: 48rem) {
    .styles_sectionTitle__arYwS {
      font-size: 3rem; } }

.styles_sectionDescription__66k4P {
  font-size: 1.125rem;
  color: #808080b8;
  line-height: 1.6;
  max-width: 36rem;
  margin: 0 auto; }

.styles_decorativeDivider__VrmD8 {
  width: 6rem;
  height: 0.125rem;
  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);
  border-radius: 0.0625rem;
  margin-top: 1rem; }

.styles_formCard__xhYPk {
  background: #8080801a;
  backdrop-filter: blur(0.5rem);
  border-radius: 1.5rem;
  padding: 2rem;
  border: #80808008;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);
  margin-bottom: 4rem;
  width: 54vw;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);
  color: #8b5cf6; }
  @media (min-width: 48rem) {
    .styles_formCard__xhYPk {
      padding: 2.5rem;
      border-radius: 2rem; } }
  .styles_formCard__xhYPk h2 {
    font-size: 2rem;
    margin: 1rem; }

@keyframes styles_gradientText__9PZwp {
  0% {
    background-position: 0% 50%; }
  50% {
    background-position: 100% 50%; }
  100% {
    background-position: 0% 50%; } }

.styles_gradientTitle__k-P5G {
  background-image: linear-gradient(90deg, #6ba5ff, #4682b4, #aa336a, #c41e3a);
  background-size: 180% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: styles_gradientText__9PZwp 6s ease infinite;
  display: inline-block; }

.styles_formContainer__NlNRo {
  margin: 0; }

.styles_signupForm__n336T {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 32rem;
  margin: 0 auto; }

.styles_inputsContainer__1O\\+Ck {
  display: flex;
  flex-direction: column;
  gap: 1rem; }

.styles_formInput__o7x5l {
  width: 100%;
  padding: 1rem 1.25rem;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid #8080802e;
  border-radius: 1rem;
  color: #808080e6;
  font-size: 1rem;
  transition: all 0.3s ease; }
  .styles_formInput__o7x5l::placeholder {
    color: #80808080; }
  .styles_formInput__o7x5l:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(218, 165, 32, 0.4);
    border-color: #DAA520; }

.styles_submitButton__2hj0j {
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: 1rem 2rem;
  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);
  border: none;
  border-radius: 1rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  color: white; }
  .styles_submitButton__2hj0j:hover {
    box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.15);
    transform: scale(1.05); }
    .styles_submitButton__2hj0j:hover::after {
      opacity: 1; }
  .styles_submitButton__2hj0j::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, #8b5cf6, #6366f1);
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 1rem; }

.styles_submitButtonText__cNite {
  position: relative;
  z-index: 10;
  color: white !important;
  font-weight: 500;
  font-size: 1.125rem; }

.styles_privacyNote__IEobI {
  font-size: 0.875rem;
  color: #80808080;
  margin-top: 1rem; }

.styles_authButtonsContainer__kGVfR {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center; }
  @media (min-width: 48rem) {
    .styles_authButtonsContainer__kGVfR {
      flex-direction: row;
      justify-content: center;
      gap: 1.5rem; } }

.styles_loginButton__qCA\\+2,
.styles_registerButton__HVCIf {
  position: relative;
  width: 100%;
  max-width: 16rem;
  padding: 1rem 2rem;
  border: 2px solid transparent;
  border-radius: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 1rem;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  color: white; }
  @media (min-width: 48rem) {
    .styles_loginButton__qCA\\+2,
    .styles_registerButton__HVCIf {
      width: auto;
      min-width: 10rem;
      max-width: 14rem; } }
  .styles_loginButton__qCA\\+2:hover,
  .styles_registerButton__HVCIf:hover {
    transform: scale(1.05);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15); }

.styles_loginButton__qCA\\+2 {
  background: rgba(255, 255, 255, 0.9);
  border-color: #6366f1;
  color: #6366f1; }
  .styles_loginButton__qCA\\+2:hover {
    background: #6366f1;
    color: white; }
  .styles_loginButton__qCA\\+2 .styles_buttonText__23avJ {
    color: #6366f1; }

.styles_registerButton__HVCIf {
  background: linear-gradient(90deg, #6366f1, #8b5cf6);
  color: white;
  border-color: transparent; }
  .styles_registerButton__HVCIf:hover {
    background: linear-gradient(90deg, #4f46e5, #7c3aed);
    transform: scale(1.05); }
  .styles_registerButton__HVCIf .styles_buttonText__23avJ {
    color: white; }

.styles_quoteSection__VCGxH {
  margin-top: 4rem; }

.styles_inspiringQuote__zkB7Q {
  font-size: 1.125rem;
  color: #808080b8;
  font-style: italic;
  line-height: 1.6; }
  @media (min-width: 48rem) {
    .styles_inspiringQuote__zkB7Q {
      font-size: 1.25rem; } }

.styles_highlightedWord__n0ETP {
  font-weight: 400;
  font-style: italic;
  margin: 0 0.75rem;
  position: relative;
  display: inline; }

.styles_sheltersHighlight__mnja- {
  color: #6366f1;
  font-size: 1.875rem;
  font-style: normal;
  margin: 0 0.75rem; }
  @media (min-width: 48rem) {
    .styles_sheltersHighlight__mnja- {
      font-size: 2.25rem; } }
  @media (min-width: 64rem) {
    .styles_sheltersHighlight__mnja- {
      font-size: 2.25rem; } }

.styles_meaningHighlight__XF55R {
  color: #8b5cf6;
  font-size: 1.875rem;
  font-style: normal; }
  @media (min-width: 48rem) {
    .styles_meaningHighlight__XF55R {
      font-size: 2.25rem; } }
  @media (min-width: 64rem) {
    .styles_meaningHighlight__XF55R {
      font-size: 2.25rem; } }

button.styles_releasesButton__N1ngg, button.styles_boothsButton__Zq3TA {
  width: 100%;
  max-width: 24rem;
  opacity: 0.75;
  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);
  color: white !important;
  border: none;
  border-radius: 1rem;
  padding: 1rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.75s ease;
  margin: 1rem 0rem; }
  button.styles_releasesButton__N1ngg:hover, button.styles_boothsButton__Zq3TA:hover {
    opacity: 0.9;
    color: white !important;
    font-size: 1.125rem;
    font-weight: 500;
    transform: scale(1.05);
    background: linear-gradient(135deg, #6366f1, #dc2626, #8b5cf6); }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/screens/LandingPage/components/ConnectionSection/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,WAAW,EAAA;;AAGb;EACE,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBCRgB;EDShB,qBAAqB,EAAA;EAErB;IANF;MAOI,eAAe,EAAA,EAElB;;AAED;EACE,mBAAmB;EACnB,gBCnBgB;EDoBhB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,WAAW;EACX,gBAAgB;EAChB,6DAA6D;EAC7D,wBAAwB;EAExB,gBAAgB,EAAA;;AAGlB;EACE,qBCvCgB;EDwChB,6BAA6B;EAC7B,qBAAqB;EACrB,aAAa;EACb,iBC9Cc;ED+Cd,gDAAgD;EAChD,mBAAmB;EACnB,WAAW;EACX,gDAAgD;EAChD,cAAc,EAAA;EAEd;IAZF;MAaI,eAAe;MACf,mBAAmB,EAAA,EAOtB;EArBD;IAkBI,eAAe;IACf,YAAY,EAAA;;AAIhB;EACE;IAAK,2BAA2B,EAAA;EAChC;IAAM,6BAA6B,EAAA;EACnC;IAAO,2BAA2B,EAAA,EAAA;;AAGpC;EACE,4EAA4E;EAC5E,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,sDAAwC;EACxC,qBAAqB,EAAA;;AAGvB;EACE,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,WAAW;EACX,qBAAqB;EACrB,0CAA0C;EAC1C,2BClGgB;EDmGhB,mBAAmB;EACnB,gBC/FgB;EDgGhB,eAAe;EACf,yBAAyB,EAAA;EAR3B;IAWI,gBCvGc,EAAA;ED4FlB;IAeI,aAAa;IACb,6CAA6C;IAC7C,qBAAqB,EAAA;;AAIzB;EACE,kBAAkB;EAClB,WAAW;EAEX,cAAc;EACd,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;EAC5C,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,YAAY,EAAA;EAbd;IAgBI,gDAAgD;IAChD,sBAAsB,EAAA;IAjB1B;MAoBM,UAAU,EAAA;EApBhB;IAyBI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oDAAoD;IACpD,UAAU;IACV,6BAA6B;IAC7B,mBAAmB,EAAA;;AAIvB;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB;EACnB,gBCjKgB;EDkKhB,gBAAgB,EAAA;;AAIlB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB,EAAA;EAEnB;IANF;MAOI,mBAAmB;MACnB,uBAAuB;MACvB,WAAW,EAAA,EAEd;;AAED;;EAEE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,YAAY,EAAA;EAEZ;IAfF;;MAgBI,WAAW;MACX,gBAAgB;MAChB,gBAAgB,EAAA,EAOnB;EAzBD;;IAsBI,sBAAsB;IACtB,6CAA6C,EAAA;;AAIjD;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc,EAAA;EAHhB;IAMI,mBAAmB;IACnB,YAAY,EAAA;EAPhB;IAWI,cAAc,EAAA;;AAMlB;EACE,oDAAoD;EACpD,YAAY;EACZ,yBAAyB,EAAA;EAH3B;IAMI,oDAAoD;IACpD,sBAAsB,EAAA;EAP1B;IAWI,YAAY,EAAA;;AAMhB;EACE,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB;EACnB,gBCpPgB;EDqPhB,kBAAkB;EAClB,gBAAgB,EAAA;EAEhB;IANF;MAOI,kBAAkB,EAAA,EAErB;;AAED;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB,EAAA;EAEjB;IANF;MAOI,kBAAkB,EAAA,EAMrB;EAHC;IAVF;MAWI,kBAAkB,EAAA,EAErB;;AAED;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB,EAAA;EAElB;IALF;MAMI,kBAAkB,EAAA,EAMrB;EAHC;IATF;MAUI,kBAAkB,EAAA,EAErB;;AAED;EACE,WAAW;EACX,gBAAgB;EAEhB,aAAa;EAYb,6DAA6D;EAC7D,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,iBAAkB,EAAA;EAzBpB;IAOI,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,8DAA8D,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.section {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.connectionSection {\n  width: 100%;\n}\n\n.contentWrapper {\n  margin: 0 auto;\n  text-align: center;\n}\n\n.headerSection {\n  margin-bottom: 3rem;\n}\n\n.sectionTitle {\n  font-size: 2.5rem;\n  font-weight: 300;\n  color: $grey90;\n  margin-bottom: 1.5rem;\n\n  @media (min-width: 48rem) {\n    font-size: 3rem;\n  }\n}\n\n.sectionDescription {\n  font-size: 1.125rem;\n  color: $grey72;\n  line-height: 1.6;\n  max-width: 36rem;\n  margin: 0 auto;\n}\n.decorativeDivider {\n  width: 6rem;\n  height: 0.125rem;\n  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);\n  border-radius: 0.0625rem;\n  // margin: 0 auto;\n  margin-top: 1rem;\n}\n\n.formCard {\n  background: $grey10;\n  backdrop-filter: blur(0.5rem);\n  border-radius: 1.5rem;\n  padding: 2rem;\n  border: $grey3;\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);\n  margin-bottom: 4rem;\n  width: 54vw;\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);\n  color: #8b5cf6;\n\n  @media (min-width: 48rem) {\n    padding: 2.5rem;\n    border-radius: 2rem;\n  }\n\n  h2 {\n    font-size: 2rem;\n    margin: 1rem;\n  }\n}\n\n@keyframes gradientText {\n  0% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n.gradientTitle {\n  background-image: linear-gradient(90deg, #6ba5ff, #4682b4, #aa336a, #c41e3a);\n  background-size: 180% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  animation: gradientText 6s ease infinite;\n  display: inline-block;\n}\n\n.formContainer {\n  margin: 0;\n}\n\n.signupForm {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  max-width: 32rem;\n  margin: 0 auto;\n}\n\n.inputsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.formInput {\n  width: 100%;\n  padding: 1rem 1.25rem;\n  background-color: rgba(255, 255, 255, 0.9);\n  border: 1px solid $grey18;\n  border-radius: 1rem;\n  color: $grey90;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n\n  &::placeholder {\n    color: $grey50;\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(218, 165, 32, 0.4);\n    border-color: #DAA520;\n  }\n}\n\n.submitButton {\n  position: relative;\n  width: 100%;\n  // max-width: 24rem;\n  margin: 0 auto;\n  padding: 1rem 2rem;\n  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);\n  border: none;\n  border-radius: 1rem;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  overflow: hidden;\n  color: white;\n\n  &:hover {\n    box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.15);\n    transform: scale(1.05);\n\n    &::after {\n      opacity: 1;\n    }\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(90deg, #8b5cf6, #6366f1);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    border-radius: 1rem;\n  }\n}\n\n.submitButtonText {\n  position: relative;\n  z-index: 10;\n  color: white !important;\n  font-weight: 500;\n  font-size: 1.125rem;\n}\n\n.privacyNote {\n  font-size: 0.875rem;\n  color: $grey50;\n  margin-top: 1rem;\n}\n\n// Authentication buttons styles\n.authButtonsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n\n  @media (min-width: 48rem) {\n    flex-direction: row;\n    justify-content: center;\n    gap: 1.5rem;\n  }\n}\n\n.loginButton,\n.registerButton {\n  position: relative;\n  width: 100%;\n  max-width: 16rem;\n  padding: 1rem 2rem;\n  border: 2px solid transparent;\n  border-radius: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  font-size: 1rem;\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);\n  color: white;\n\n  @media (min-width: 48rem) {\n    width: auto;\n    min-width: 10rem;\n    max-width: 14rem;\n  }\n\n  &:hover {\n    transform: scale(1.05);\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  }\n}\n\n.loginButton {\n  background: rgba(255, 255, 255, 0.9);\n  border-color: #6366f1;\n  color: #6366f1;\n\n  &:hover {\n    background: #6366f1;\n    color: white;\n  }\n\n  .buttonText {\n    color: #6366f1;\n  }\n\n\n}\n\n.registerButton {\n  background: linear-gradient(90deg, #6366f1, #8b5cf6);\n  color: white;\n  border-color: transparent;\n\n  &:hover {\n    background: linear-gradient(90deg, #4f46e5, #7c3aed);\n    transform: scale(1.05);\n  }\n\n  .buttonText {\n    color: white;\n  }\n\n\n}\n\n.quoteSection {\n  margin-top: 4rem;\n}\n\n.inspiringQuote {\n  font-size: 1.125rem;\n  color: $grey72;\n  font-style: italic;\n  line-height: 1.6;\n\n  @media (min-width: 48rem) {\n    font-size: 1.25rem;\n  }\n}\n\n.highlightedWord {\n  font-weight: 400;\n  font-style: italic;\n  margin: 0 0.75rem;\n  position: relative;\n  display: inline;\n}\n\n.sheltersHighlight {\n  color: #6366f1;\n  font-size: 1.875rem;\n  font-style: normal;\n  margin: 0 0.75rem;\n\n  @media (min-width: 48rem) {\n    font-size: 2.25rem;\n  }\n\n  @media (min-width: 64rem) {\n    font-size: 2.25rem;\n  }\n}\n\n.meaningHighlight {\n  color: #8b5cf6;\n  font-size: 1.875rem;\n  font-style: normal;\n\n  @media (min-width: 48rem) {\n    font-size: 2.25rem;\n  }\n\n  @media (min-width: 64rem) {\n    font-size: 2.25rem;\n  }\n}\n\nbutton.releasesButton, button.boothsButton {\n  width: 100%;\n  max-width: 24rem;\n  // margin: 0 auto;\n  opacity: 0.75;\n\n  &:hover {\n    opacity: 0.9;\n    color: white !important;\n    font-size: 1.125rem;\n    font-weight: 500;\n    transform: scale(1.05);\n    background: linear-gradient(135deg, #6366f1, #dc2626, #8b5cf6);\n\n  }\n\n  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);\n  color: white !important;\n  border: none;\n  border-radius: 1rem;\n  padding: 1rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.75s ease;\n  margin: 1rem 0rem ;\n}\n\n\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `styles_section__Kuf0D`,
	"connectionSection": `styles_connectionSection__WSQWQ`,
	"contentWrapper": `styles_contentWrapper__wJ6Mv`,
	"headerSection": `styles_headerSection__7fndT`,
	"sectionTitle": `styles_sectionTitle__arYwS`,
	"sectionDescription": `styles_sectionDescription__66k4P`,
	"decorativeDivider": `styles_decorativeDivider__VrmD8`,
	"formCard": `styles_formCard__xhYPk`,
	"gradientTitle": `styles_gradientTitle__k-P5G`,
	"gradientText": `styles_gradientText__9PZwp`,
	"formContainer": `styles_formContainer__NlNRo`,
	"signupForm": `styles_signupForm__n336T`,
	"inputsContainer": `styles_inputsContainer__1O+Ck`,
	"formInput": `styles_formInput__o7x5l`,
	"submitButton": `styles_submitButton__2hj0j`,
	"submitButtonText": `styles_submitButtonText__cNite`,
	"privacyNote": `styles_privacyNote__IEobI`,
	"authButtonsContainer": `styles_authButtonsContainer__kGVfR`,
	"loginButton": `styles_loginButton__qCA+2`,
	"registerButton": `styles_registerButton__HVCIf`,
	"buttonText": `styles_buttonText__23avJ`,
	"quoteSection": `styles_quoteSection__VCGxH`,
	"inspiringQuote": `styles_inspiringQuote__zkB7Q`,
	"highlightedWord": `styles_highlightedWord__n0ETP`,
	"sheltersHighlight": `styles_sheltersHighlight__mnja-`,
	"meaningHighlight": `styles_meaningHighlight__XF55R`,
	"releasesButton": `styles_releasesButton__N1ngg`,
	"boothsButton": `styles_boothsButton__Zq3TA`
};
export default ___CSS_LOADER_EXPORT___;
